import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { MatDividerModule } from '@angular/material/divider'
import { MatIconModule } from '@angular/material/icon'
import { TranslateModule } from '@ngx-translate/core'
import { ThumbRatingModule } from 'shared/components/thumb-rating/thumb-rating.module'

import { FinishViewDialogComponent } from './finish-view-dialog.component'

@NgModule({
	declarations: [FinishViewDialogComponent],
	imports: [
		CommonModule,
		TranslateModule,
		MatDialogModule,
		MatButtonModule,
		MatIconModule,
		MatDividerModule,
		ThumbRatingModule,
	],
	exports: [FinishViewDialogComponent],
})
export class FinishViewDialogModule {}
